/**
 * Forces a file download by fetching it as a blob first (works with cross-origin URLs)
 * @param url - The URL of the file to download
 * @param filename - Optional filename for the downloaded file
 */
export const forceDownload = async (url: string, filename?: string) => {
  try {
    // Fetch the file as a blob
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.statusText}`);
    }

    // Get the blob from the response
    const blob = await response.blob();

    // Create a blob URL
    const blobUrl = window.URL.createObjectURL(blob);

    // Create a temporary anchor element
    const link = document.createElement("a");
    link.href = blobUrl;

    // Set download attribute to force download
    // If filename is provided, use it; otherwise extract from URL or use default
    link.download = filename ?? url.split("/").pop()?.split("?")[0] ?? "download";

    // Append to body (required for Firefox)
    document.body.append(link);

    // Trigger the download
    link.click();

    // Clean up - remove the link and revoke the blob URL
    setTimeout(() => {
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
  } catch {
    // Fallback to opening in new tab if download fails
    openInNewTab(url);
  }
};

/**
 * Legacy function for backwards compatibility
 * Opens URL in a new tab
 */
export const openInNewTab = (url: string) => {
  const win = window.open(url, "_blank");
  if (win) win.focus();
};
